<div class="camera-modal-container">
    <div class="camera-modal-header modal-header">
        <h2 class="camera-modal-title">{{"HOME.CAPTURE_PHOTO" | translate}}</h2>
        <button class="close-button btn-close " aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="camera-modal-content">
        <div class="video-preview">
            <div class="error-message" *ngIf="errMessage">
                <p>{{ errMessage }}</p>
            </div>
            <video class="video-element" #video autoplay [hidden]="capturedImage"></video>
            <img class="video-element" #preview [src]="capturedImage" *ngIf="capturedImage" alt="Captured image">
            <canvas #canvas style="display: none;"></canvas>
        </div>

        <div class="camera-btn-group">
            <ng-container *ngIf="!capturedImage">
                <button class="btn blue-btn" (click)="captureImage()">{{"HOME.CAPTURE" | translate}}</button>
                <!-- <button class="btn grey-btn" (click)="switchCamera()">
                    {{"HOME.SWITCH_CAMERA" | translate}}
                </button> -->
            </ng-container>
            <ng-container *ngIf="capturedImage">
                <button class="btn blue-btn" (click)="saveImage()">
                    {{"HOME.SAVE" | translate}}
                </button>
                <button class="btn grey-btn" (click)="retakeImage()">
                    {{"HOME.RETAKE_PHOTO" | translate}}
                </button>
            </ng-container>
        </div>
    </div>
</div>